export const yelloyTabStyles = {
  button: {
    textTransform: "none",
    fontWeight: "500",
    fontSize: "14px",
    color: "#2A323E",
    fontFamily: "DM Sans",
    lineHeight: "20px",
    minWidth: "0",
    minHeight: "14px",
    backgroundColor: "transparent !important",
    border: "none !important",
    padding: "0px 4px 28px !important",
    "&.Mui-selected": {
      color: "#2A323E !important",
    },
    "&.MuiTab-wrapper": {
      width: "fit-content",
    },
  },
  bar: {
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      height: "4px",
    },
    // "& .MuiTabs-indicatorSpan": {
    //   width: "100%",
    //   borderBottom: "4px solid rgb(252, 207, 89)",
    //   borderRight: "4px solid transparent",
    //   borderLeft: "4px solid transparent",
    // },
    // TODO For future use Yellow line under TABS
    "&.MuiTabs-root": {
      minHeight: "0",
    },
  },
};
